import { type FC, useCallback } from 'react'

import { VaultMediaType } from '@api'

import CloseIcon from '@/assets/icons/icon-close.svg'
import { MediaThumb } from '@/components/ui/MediaThumb'
import { UploadedFileDetails } from '@/modules/chatting/types'
import { isVideo } from '@/utils/file'

interface Props {
  item: UploadedFileDetails
  onClear: (mediaItem: UploadedFileDetails) => void
}

export const UploadedMediaPreview: FC<Props> = ({ item, onClear }) => {
  const handleClear = useCallback(() => {
    onClear(item)
  }, [item, onClear])

  const mediaType = isVideo(item.name)
    ? VaultMediaType.VIDEO
    : VaultMediaType.PHOTO

  return (
    <div className="relative flex h-full w-full items-start justify-end p-2">
      <div className="absolute left-0 top-0 z-0 h-full w-full">
        <MediaThumb
          className="h-full w-full object-cover"
          src={item.thumbs?.[0]?.url}
          alt={item.name}
          mediaType={mediaType}
        />
      </div>

      <div
        onClick={handleClear}
        className="relative z-10 flex cursor-pointer items-center justify-center text-xs text-white"
      >
        <div className="rounded-full bg-[rgba(0,0,0,0.4)] p-1 hover:bg-[rgba(0,0,0,0.5)]">
          <CloseIcon className="text-white" />
        </div>
      </div>
    </div>
  )
}
